export default __webpack_public_path__ + "static/media/os.76f385a2.svg";